import { apis } from '@/config';
import { api } from '@/api/api';
class MailTemplateImplApi {
    constructor() {
        this.name = apis.mailTemplateImplApi;
        this.systemApi = api.getSystemApi();
        this.http = api.getDataTransApi();
    }
    init() {
        return this.name;
    }
    async handlePromise(promise) {
        var _a, _b, _c;
        try {
            const res = await promise;
            const { data } = res;
            return data;
        }
        catch (e) {
            return {
                message: ((_a = e) === null || _a === void 0 ? void 0 : _a.message) || ((_c = (_b = e) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message),
                success: false,
            };
        }
    }
    async doGetMailTemplateList(params, _account) {
        const url = this.systemApi.getUrl('getMailTemplateList');
        const res = await this.handlePromise(this.http.get(url, params, { _account }));
        return res;
    }
    async doGetMailTemplateDetail(params, _account) {
        const url = this.systemApi.getUrl('getMailTemplateDetail');
        const res = await this.handlePromise(this.http.get(url, params, { _account }));
        return res;
    }
    async doSaveMailTemplate(params, _account) {
        const url = this.systemApi.getUrl('saveMailTemplate');
        const res = await this.handlePromise(this.http.post(url, params, { contentType: 'json', _account }));
        return res;
    }
    async doDeleteMailTemplate(params, email) {
        const url = this.systemApi.getUrl('deleteMailTemplate');
        const res = await this.handlePromise(this.http.post(url, params, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            _account: email,
        }));
        return res;
    }
    async doSaveMailTemplateUseTime(params, _account) {
        const url = this.systemApi.getUrl('saveMailTemplateUseTime');
        const res = await this.handlePromise(this.http.post(url, params, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            _account,
        }));
        return res;
    }
    async getWaimaoRecommendTemplateTagList(templateCategory = 'LX') {
        const url = this.systemApi.getUrl('getWaimaoRecommendTemplateTagList');
        const res = await this.handlePromise(this.http.get(url, { templateCategory }));
        return res;
    }
    async getWaimaoRecommendTemplateList(req) {
        const url = this.systemApi.getUrl('getWaimaoRecommendTemplateList');
        const res = await this.handlePromise(this.http.post(url, req, { contentType: 'json' }));
        return res;
    }
    async getQueryCondition(req) {
        const url = this.systemApi.getUrl('getQueryCondition');
        const res = await this.handlePromise(this.http.get(url, req));
        if (res.success && res.data) {
            return res.data;
        }
        throw new Error('网络错误');
    }
    async getTemplateList(req) {
        const url = this.systemApi.getUrl('getTemplateList');
        const res = await this.handlePromise(this.http.post(url, req, {
            contentType: 'json',
        }));
        if (res.success && res.code === 200) {
            return res.data || null;
        }
        throw new Error('网络错误');
    }
    async getTemplateTop(req) {
        const url = this.systemApi.getUrl('getTemplateTop');
        const res = await this.handlePromise(this.http.get(url, req, {
            contentType: 'json',
        }));
        if (res.success && res.code === 200) {
            return res.data || [];
        }
        throw new Error('网络错误');
    }
    async templateSearch(req) {
        const url = this.systemApi.getUrl('templateSearch');
        const res = await this.handlePromise(this.http.post(url, req, {
            contentType: 'json',
        }));
        if (res.success && res.code === 200) {
            return res.data || [];
        }
        throw new Error('网络错误');
    }
    async templateQueryLimit() {
        const url = this.systemApi.getUrl('templateQueryLimit');
        const res = await this.handlePromise(this.http.get(url, {
            templateType: 'PERSONAL',
            templateCategory: 'LX-WAIMAO',
        }));
        if (res.success && res.data) {
            return res.data;
        }
        throw new Error('网络错误');
    }
    async fetchSuggestTemplates() {
        const url = this.systemApi.getUrl('fetchSuggestTemplates');
        const res = await this.handlePromise(this.http.get(url, {
            templateCategory: 'LX-WAIMAO',
        }));
        if (res.success && res.data) {
            return res.data;
        }
    }
    async fetchNewTemplateUpdateTime() {
        const url = this.systemApi.getUrl('fetchNewTemplateUpdateTime');
        const res = await this.handlePromise(this.http.get(url, {
            templateCategory: 'LX-WAIMAO',
        }));
        if (res.success && res.data) {
            return res.data;
        }
    }
    async getTemplateTagList(params) {
        const url = this.systemApi.getUrl('getTemplateTagList');
        const res = await this.handlePromise(this.http.get(url, params));
        return res;
    }
    async deleteTemplateTags(params) {
        const url = this.systemApi.getUrl('deleteTemplateTags');
        const res = await this.handlePromise(this.http.post(url, params, { contentType: 'json' }));
        return res;
    }
    async saveOrUpdateTemplateTag(params) {
        const url = this.systemApi.getUrl('saveOrUpdateTemplateTag');
        const res = await this.handlePromise(this.http.post(url, params, { contentType: 'json' }));
        return res;
    }
}
const mailTemplateImplApi = new MailTemplateImplApi();
api.registerLogicalApi(mailTemplateImplApi);
export default mailTemplateImplApi;
